module.exports = __webpack_public_path__ + "img/a2.7101800f.png";